<template>
  <el-dialog
  v-if="isShowSyncToTTC"
    :visible.sync="isShowSyncToTTC"
    title="铺货到中国土特产"
    width="500px"
    @close="close"
  >
    <div style="margin-bottom: 12px;">商品状态：</div>
    <el-radio-group v-model="ttcIsOnSale">
      <el-radio :label="1">上架</el-radio>
      <el-radio :label="0">下架</el-radio>
    </el-radio-group>

    <div style="padding-top: 24px">
      <el-button :loading="isSubmiting" type="primary" size="mini" @click="submitBtn">确定</el-button>
      <el-button size="mini" @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      isShowSyncToTTC: false,
      ttcIsOnSale: 1,
      isSubmiting: false,
    };
  },
  methods: {
    show(row) {
      this.row = row;
      this.isShowSyncToTTC = true;
    },
    close() {
      this.isShowSyncToTTC = false;
    },
    submitBtn() {
      this.isSubmiting = true;
      this.$axios.post(this.$api.goodsmanage.yxGoodsSyncZGTTC, {
        id: this.row.id,
        isOnSale: this.ttcIsOnSale,
      })
      .then((res) => {
        if (res.code !== 0) {
          this.isSubmiting = false;
          // this.$message.error(res.msg || '铺货失败');
          return;
        }
        this.$message.success('铺货成功');
        this.$emit('syncToTTCSuccess');
        this.isSubmiting = false;
        this.close();
      })
      .catch((e) => {
        this.isSubmiting = false;
        // this.$message.error(e.msg || '操作失败');
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
